import { Button, Form, Input, Modal } from "antd";
import { camelCaseToWords } from "../../utils/string.utils";
import { ReactNode, useEffect, useState } from "react";
import { Rule } from "antd/es/form";

export const ObjectToEditForm = (props: { title: ReactNode,action:ReactNode, object: any, filter:(key:string)=>boolean, onSave:(data:any)=>Promise<boolean>, rules:{[key:string]:Rule[]}, inputLookup?: {[key:string]: ReactNode}, labelTransform?: {[key:string]:string}}) => {
    const [form] = Form.useForm();
    const [show, setShow] = useState<boolean> (false);
    const save = async ()=> {
        let saveResult = false;
        try {
            await form.validateFields();
            let data = await form.getFieldsValue();
            saveResult = await props.onSave(data);
            
        } catch (err) {
            console.log("failed to save object", saveResult)
        }

        if(saveResult)
        {
            setShow(false)
        }
        
    }

    useEffect(()=>{
        form.validateFields();
    })
    return (
        <>
        <Button onClick={()=>setShow(true)}>{props.action} </Button>
        {show && 
        <Modal 
            open={show}
            title={props.title}
            onCancel={()=>setShow(false)}
            onOk={()=>save()}
            okText="Save"
            width={'80vw'}
            destroyOnClose
        >
            <Form
                form={form}
                initialValues={props.object}
                defaultValue={props.object}
                validateTrigger={"onChange"}
                layout={"vertical"}
            >
                {Object.entries(props.object).filter(([key,value])=>props.filter(key)).map(([key, value])=>{
                    let label = camelCaseToWords(key);
                    if(props.labelTransform && props.labelTransform[key])
                    {
                        label = props.labelTransform[key]
                    }
                    return (
                        <Form.Item key={key} name={key} label={camelCaseToWords(key)} rules={props.rules[key] ?? []} hasFeedback>
                            {props.inputLookup ? (props.inputLookup[key] ? props.inputLookup[key] : <Input.TextArea autoSize />) : <Input.TextArea autoSize />}
                        </Form.Item>
                    )
                })}

            </Form>
        </Modal>
        
        }
        </>
    )
}